import cloneDeep from 'lodash.clonedeep';

const escapeAttributeValue = value => String(value).replace(/"/g, '&quot;');

const createMarkTag = ({ placeholder, refId = null }) => {
    const attrs = [
        'class="pl-custom-highlight"',
        `data-placeholder="${escapeAttributeValue(placeholder)}"`,
        refId ? `data-ref-id="${escapeAttributeValue(refId)}"` : null,
    ]
        .filter(Boolean)
        .join(' ');

    return `<mark ${attrs}>${placeholder}</mark>`;
};

export const parseTipTapJSONToPlainText = (json = {}) => {
    let data = cloneDeep(json);
    if (typeof json === 'string') {
        try {
            data = JSON.parse(json);
        } catch (error) {
            return json;
        }
    }

    const getTextFromMirrorDocument = mirrorValue => {
        const { content } = mirrorValue;
        if (!content || content.length === 0) {
            return '';
        }
        let out = '';
        for (const node of content) {
            out += getTextFromMirrorNode(node) + '\n';
        }
        out = out.trim();
        return out;
    };

    const formatPlaceholder = mark => {
        const placeholder = mark?.attrs?.placeholder;
        if (!placeholder) {
            return null;
        }
        const refId = mark?.attrs?.refId;
        return `[${placeholder}${refId ? `:${refId}` : ''}]`;
    };

    const getTextFromMirrorNode = node => {
        if (!node) {
            return '';
        }

        switch (node.type) {
            case 'text': {
                const highlightMark = node?.marks?.find(mark => mark?.type === 'highlight');
                if (highlightMark) {
                    return formatPlaceholder(highlightMark) || `[${node.text}]`;
                }
                return node.text;
            }
            case 'hardBreak':
                return '\n';
            case 'paragraph':
                if (!node.content) {
                    return '';
                }
                return node.content.map(subNode => getTextFromMirrorNode(subNode)).join('');
            default:
                return '';
        }
    };
    return getTextFromMirrorDocument(data);
};

export const addTipTapMarkTag = (text = '') => {
    if (!text) {
        return '';
    }

    return text
        .replace(/\[name\]/g, () => createMarkTag({ placeholder: 'name' }))
        .replace(/\[last_name\]/g, () => createMarkTag({ placeholder: 'last_name' }))
        .replace(/\[location\]/g, () => createMarkTag({ placeholder: 'location' }))
        .replace(
            /\[survey(?::([^\]]+))?\]/g,
            (_, id) => `${createMarkTag({ placeholder: 'survey', refId: id || null })}&#8203;`,
        )
        .replace(
            /\[coupon(?::([^\]]+))?\]/g,
            (_, id) => `${createMarkTag({ placeholder: 'coupon', refId: id || null })}&#8203;`,
        )
        .replace(/\n/g, '<br>');
};

const TextEditorPlaceholders = ['name', 'last_name', 'location', 'survey', 'coupon'];

export const testEditorLength = (value, maxLength) => {
    let lengthWithoutBrackets = value.length;
    TextEditorPlaceholders.forEach(ph => {
        const re = new RegExp(`\\[${ph}\\]`, 'g');
        const match = value.match(re);

        if (match) {
            lengthWithoutBrackets -= 2 * match.length;
        }
    });
    return lengthWithoutBrackets <= maxLength;
};
